import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type RegistrationGroupFormType, store } from "..";
import {
  setRegistrationGroup,
  setRegistrationGroupLoading,
} from "../slices/registrationGroupSlice";

export const getRegistrationGroups = async (notify: MessageInstance) => {
  try {
    store.dispatch(setRegistrationGroupLoading(true));
    const response = await privateAPI.get("/onboarding/registration-groups");
    if (response) {
      store.dispatch(setRegistrationGroupLoading(false));
      store.dispatch(setRegistrationGroup(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setRegistrationGroupLoading(false));
    console.error("Get Registration Group Error:", error);
    errorHandler(error, notify);
  }
};

export const createRegistrationGroup = async (
  notify: MessageInstance,
  payload: RegistrationGroupFormType,
) => {
  try {
    store.dispatch(setRegistrationGroupLoading(true));
    const { data } = await privateAPI.post(
      "/onboarding/registration-groups",
      payload,
    );
    notify.success("Registration Group created successfully!");
    return data;
  } catch (error) {
    console.error("Create Registration Group Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setRegistrationGroupLoading(false));
  }
};

export const updateRegistrationGroup = async (
  notify: MessageInstance,
  payload: RegistrationGroupFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setRegistrationGroupLoading(true));
    const { data } = await privateAPI.put(
      `/onboarding/registration-groups/${payload.id}`,
      payload,
    );
    notify.success("Registration Group updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Registration Group Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setRegistrationGroupLoading(false));
  }
};

export const deleteRegistrationGroup = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setRegistrationGroupLoading(true));
    const response = await privateAPI.delete(
      `/onboarding/registration-groups/${id}`,
    );
    if (response) {
      getData && (await getRegistrationGroups(notify));
    }
    notify.success("Registration Group deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Registration Group Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setRegistrationGroupLoading(false));
  }
};
